import React, { useState } from "react";
import {
  Box,
  Grid,
 
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useFormikContext } from "formik";
import { useWebSocket } from "../../../../contexts/WebSocketContext";
import { useGeneratePostRephraseMutation } from "../../../../redux/slices/featuresApiSlice";
import RewriteModal from "../../SidePanel/global-rewrite-modal/rewrite-modal";
import { LoadingButton } from "@mui/lab";
import { Tooltip } from "@mui/material";
import { BsMagic } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import GlobalTextField from "../../FeaturesTemplate/FeaturesFields/GlobalTextField";
/** Clean HTML/newlines -> single-line inline text */
const sanitizeInlineText = (value) => {
  if (value == null) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = String(value);
  let text = tmp.textContent || tmp.innerText || "";
  text = text.replace(/\r?\n+/g, " ");
  text = text.replace(/\s{2,}/g, " ");
  text = text.replace(/\u00A0/g, " ");
  return text.trim();
};

const RephraseModal = ({ selectedHTML, onSave }) => {
  const [instruction, setInstruction] = useState("");
  const [customize, setCustomize] = useState(false);
  const [openRewriteModal, setOpenRewriteModal] = useState(false);
  const { t } = useTranslation();

  const [generatePostRephrase, { isLoading }] =
    useGeneratePostRephraseMutation();
  const { setOpenRephraseModal } = useWebSocket();
  const formikProps = useFormikContext();

  const handleRephrase = async () => {
    if (!selectedHTML) return;

    try {
      let instructionText = customize ? instruction.trim() : "";
      const appendPhrase = ", en gardant le format HTML";
      if (instructionText) {
        instructionText = instructionText.endsWith(appendPhrase)
          ? instructionText
          : instructionText + appendPhrase;
      }

      const res = await generatePostRephrase({
        selectedText: selectedHTML, // full HTML
        ...(instructionText ? { instruction: instructionText } : {}),
        stream: false,
      }).unwrap();

      if (res?.status === 200) {
        formikProps.setFieldValue("rephrase_rewrite", res.data ?? "");
        setOpenRewriteModal(true);
      } else {
        console.error("Rephrase API failed", res);
      }
    } catch (err) {
      console.error("Error generating rephrase", err);
    }
  };

  const saveSelectedVersion = (data) => {
    if (onSave) onSave(data);
    formikProps.setFieldValue("rephrase_rewrite", "");
    setOpenRewriteModal(false);
    setOpenRephraseModal(false);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        height: "100vh",
        width: {
          lg: "calc(100vw - 500px)",
          md: "calc(100vw - 350px)",
          xs: "100%",
        },
        display: "flex",
        mt: { md: "48px !important", xs: "unset" },
        left: 0,
        top: 0,
        bgcolor: "#000000a1",
        zIndex: 99999,
      }}
    >
      {openRewriteModal ? (
        <RewriteModal
          previous={selectedHTML}
          rewritten={formikProps.values.rephrase_rewrite}
          save={saveSelectedVersion}
          label="Rephrased Version"
          setOpenModal={setOpenRewriteModal}
          rewriteFieldName="rephrase_rewrite"
        />
      ) : (
        <div className="m-auto bg-white rounded-xl w-[80%] max-w-[500px]">
          <div className="flex justify-between p-4 items-center border-b-[3px] border-slate-200">
            <p>Rewrite Selection</p>
            <Close
              onClick={() => {
                setCustomize(false);
              formikProps.setFieldValue("customize_prompt", "");
              formikProps.setFieldTouched("customize_prompt", false);
                setOpenRephraseModal(false)}}
              className="cursor-pointer"
              sx={{ fontSize: 32 }}
            />
          </div>
          <div className="px-4 mt-4">
<div
            className="w-full p-2 border border-black/20 rounded-md px-4 max-h-48 overflow-auto"
            dangerouslySetInnerHTML={{ __html: selectedHTML }}
          />
          </div>
          
          <div className="pt-0 px-4">
            {/* Toggle Switch */}
            <div className="mt-4 inline-flex items-center h-6">
                    <label className="inline-flex items-center cursor-pointer relative">
                      <input
                        type="checkbox"
                        name="customize"
                        checked={customize}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setCustomize(checked);

                          // ✅ clear input when turning off
                          if (!checked) {
                            formikProps.setFieldValue("customize_prompt", "");
                          }
                        }}
                        className="sr-only peer"
                      />
                      <div className="relative w-11 h-6 bg-gray_local-400 peer-checked:bg-blue-50 transition-colors duration-200 rounded-full peer peer-checked:after:translate-x-full after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-transform after:box-border"></div>
                    </label>
                    <span className="ms-3 text-sm">
                                    {t("custom-instructions", "Instructions personnalisées")}

                    </span>
                  </div>

            {/* Show Instruction only if customize = true */}
            {customize && (
              <Grid item lg={12} xs={12}>
                <p>
                  {t("Instruction", "Instruction")}
                  <span className="text-red-500 ml-1">*</span>
                </p>
                <GlobalTextField
                  formikProps={formikProps}
                  name={"customize_prompt"}
                  placeholder={t("Ex: Make it more formal", "Ex: Rends-le plus formel")}
                  isRequired={true}
                  multipleLines={true}
                  maxLength={1000}
                />
              </Grid>
            )}

            <div className="flex justify-end my-4">
              <Tooltip
                title={
                  customize && !instruction.trim()
                    ? "Please enter instruction to generate"
                    : ""
                }
                slotProps={{
                  popper: { sx: { zIndex: 99999999 } },
                }}
              >
                <span>
                  <LoadingButton
                    startIcon={<BsMagic />}
                    loading={isLoading}
                    onClick={handleRephrase}
                    variant="contained"
                    disabled={isLoading || (customize && !instruction.trim())}
                    sx={{
                      textTransform: "none",
                      bgcolor: "#8b5cf6",
                      "&:hover": { bgcolor: "#7c3aed" },
                    }}
                  >
                    Rewrite Selection
                  </LoadingButton>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      )}
    </Box>
  );
};

export default RephraseModal;
